import script from "./KnowledgeBaseNode.vue?vue&type=script&setup=true&lang=js"
export * from "./KnowledgeBaseNode.vue?vue&type=script&setup=true&lang=js"

import "./KnowledgeBaseNode.vue?vue&type=style&index=0&id=55abc8c9&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55abc8c9"]])

export default __exports__